module.exports = __webpack_public_path__ + "6031e262482672d3b2a065ea8ab83712.png";


//////////////////
// WEBPACK FOOTER
// ./routes/home/in-parliament.png
// module id = qQn4
// module chunks = 3